import * as signalR from "@microsoft/signalr";
import { Session } from "../framework/session/session";
import { useCallback, useEffect } from "react";
import { HubMessage } from "../models/common/hubmessage";

const hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(process.env.REACT_APP_API_ROOT_URL + "hub", { accessTokenFactory: () => Session.getAccessToken() })
    .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: () => 5000
    })
    .build();

hubConnection.onclose((err) => console.log("signalr: connection closed", err));
hubConnection.onreconnecting(() => console.log("signalr: reconnecting"));
hubConnection.onreconnected(() => console.log("signalr: reconnected"));

export function signalRStart() {
    if (hubConnection.state === signalR.HubConnectionState.Disconnected) {
        hubConnection.start().catch(err => console.error(err));
    }
}

export function signalRStop() {
    if (hubConnection.state !== signalR.HubConnectionState.Disconnected) {
        hubConnection.stop().catch(err => console.error(err));
    }
}

export function useSignalRMessage<T extends HubMessage["type"]>(type: T, handler: (msg: Extract<HubMessage, {type: T}>) => void) {

    const callback = useCallback((msg: HubMessage) => {
        if (msg.type === type) {
            // @ts-expect-error: dynamic type
            handler(msg);
        }
    }, []);

    useEffect(() => {
        hubConnection.on("message", callback);
        return () => hubConnection.off("message", callback);
    }, []);
}